import { buildStateNode } from '../../build-state-node'

import { reset, checkLabelValues, autofillSKUTypeIfNecessary } from '@/models/createWarehouseReceivingOrder/steps/howWillInventoryArrive/actions/index'
import { resetEstimatedArrivalDate, resetBillOfLading } from '@/models/createWarehouseReceivingOrder/steps/arrivalDetails/actions/index'

import { savePackagingType } from './actions'

const STEP_NAME = 'howWillInventoryArrive'
const EDIT_NAME = STEP_NAME + '.' + 'valid'

const INPUT = {
  packageTypeSelected: {
    actions: [resetEstimatedArrivalDate, resetBillOfLading, autofillSKUTypeIfNecessary]
  }
}

const stateNodeGenerator = buildStateNode({
  initial: 'empty',
  states: {
    empty: {
      onEntry: [reset],
      on: {
        INPUT,
        EDIT_WRO_LOCKED: 'allValuesProvided'
      }
    },
    packageTypeSelected: {
      on: {
        PACKAGE_TYPE_SELECTED: 'labelTypeSelected',
        NO_LABEL_OPTION_NEEDED: 'valid'
      }
    },
    labelTypeSelected: {
      on: {
        LABEL_TYPE_SELECTED: 'allValuesProvided',
        ADDRESS_UPDATED: 'allValuesProvided'
      }
    },
    allValuesProvided: {
      onEntry: [checkLabelValues],
      on: {
        ADDRESS_ADDED: 'valid',
        ADDRESS_NOT_ADDED: 'labelTypeSelected'
      }
    },
    valid: {
      onEntry: [autofillSKUTypeIfNecessary],
      states: {
        saving: {
          on: {
            SAVE_FAIL: 'error'
          }
        },
        error: {}
      },
      on: {
        SAVE: {
          '.saving': {
            actions: [savePackagingType]
          }
        },
        LABEL_TYPE_SELECTED: 'allValuesProvided',
        ADDRESS_UPDATED: 'allValuesProvided',
        CLEAR: 'empty'
      }
    }
  }
})

export const howWillInventoryArrive = {
  name: STEP_NAME,
  editState: EDIT_NAME,
  stateNodeGenerator
}
